import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import type { ReactNode } from 'react';

export interface ISectionHeadingProps {
  children: ReactNode;
  marginBottom?: number;
}

export const SectionHeading = ({ children, marginBottom = 8 }: ISectionHeadingProps) => (
  <Typography
    as="h3"
    bold
    color={colors.neutral[600]}
    style={{ fontSize: 18, margin: 0, marginBottom }}
  >
    {children}
  </Typography>
);
